<template>
    <div
        class="picture-view-modal"
        v-on:keyup.alt.67="copy_picture_path"
        tabindex="0"
    >
        <div
            class="view-wrap"
            tabindex="0"
            v-on:keyup.left="item_prev"
            v-on:keyup.right="item_next"
        >
            <div class="view-modal-header">
                <div
                    class="float-image-box"
                    tabindex="0"
                    v-on:keyup.left="item_prev"
                    v-on:keyup.right="item_next"
                >
                    <iframe :src="itemData.preview_url" alt="" />
                </div>
                <v-btn
                    class="black-btn slide slide-prev"
                    v-if="itemIndex !== 0"
                    @click="item_prev"
                >
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-btn class="black-btn slide slide-next" @click="item_next">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <information-modal
                    ref="notesInformation"
                    :notes="data.notes"
                ></information-modal>
            </div>
            <div class="view-modal-body scrollbar">
                <div class="picture-info-content">
                    <template v-if="changeCurrentData">
                        <div class="infor-head">
                            <div
                                class="modal-operation-area d-flex justify-content-between align-items-center"
                            >
                                <div class="file-path-box">
                                    <input
                                        type="text"
                                        class="file-path-input"
                                        :value="data.path"
                                        ref="filePathInput"
                                    />
                                    <p
                                        class="file-path"
                                        @click="copy_picture_path"
                                    >
                                        {{ data.path }}
                                        <!-- {{
                  data.path.match(/(\w+):\/\/([^\:|\/]+)\/(.*?)\/(.*)\/+/i)[4]
                }} -->
                                    </p>
                                </div>
                                <div class="functional-area d-flex">
                                    <v-btn
                                        class="collect-btn icon-btn icon-information black-btn"
                                        v-if="data.notes"
                                        @click.stop="open_information_modal"
                                    >
                                        <v-icon>mdi-information-outline</v-icon>
                                    </v-btn>
                                    <v-btn
                                        :class="[
                                            'like-btn black-btn',
                                            data.isLikes && 'favor',
                                        ]"
                                        @click="likes($event)"
                                    >
                                        <v-icon class="notlikes"
                                            >mdi-thumb-up-outline</v-icon
                                        >
                                        <v-icon class="likes"
                                            >mdi-thumb-up</v-icon
                                        >
                                        <span v-if="data.likes">{{
                                            data.likes
                                        }}</span>
                                    </v-btn>

                                    <v-btn
                                        v-if="
                                            !$store.state.global.isNewBeveliver
                                        "
                                        :class="[
                                            'collect-btn black-btn',
                                            data.isFavorited && 'turned',
                                        ]"
                                        @click="favorites"
                                    >
                                        <v-icon class="turned-out"
                                            >mdi-bookmark-outline</v-icon
                                        >
                                        <v-icon class="turned-in"
                                            >mdi-bookmark</v-icon
                                        >
                                    </v-btn>

                                    <v-btn
                                        class="gradient-bg down-btn"
                                        @click="
                                            download(
                                                data.download_url,
                                                data.fileId
                                            )
                                        "
                                    >
                                        <i
                                            class="v-icon"
                                            v-html="$P.downloadIcon"
                                        ></i>
                                        <span>{{ $TL.downloadImage }}</span>
                                    </v-btn>
                                </div>
                            </div>
                            <div class="title-content">
                                <h2 class="image-title">{{ data.name }}</h2>
                                <p class="update-date">
                                    {{ data.createdTime }}
                                </p>
                            </div>
                        </div>
                        <div class="info-body">
                            <!-- todo 判断是否有字幕翻译 -->
                            <div
                                class="translation-control-content"
                                v-if="
                                    data.translation &&
                                    !$store.state.global.isNewBeveliver
                                "
                            >
                                <h3>{{ $TL.translationControl }}</h3>
                                <div class="control">
                                    <p>{{ data.translation }}</p>
                                </div>
                            </div>
                            <div
                                class="tags-content"
                                v-if="data.tags && data.tags.length"
                            >
                                <h3>Tags</h3>
                                <div class="tags-list" v-if="data.tags.length">
                                    <a
                                        href="javascript:;"
                                        class="v-btn def"
                                        v-for="(tag, i) in data.tags"
                                        :key="i"
                                        @click="get_tags_schema(tag, i)"
                                        >{{ tag }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="v-spinner-border"></div>
                    </template>
                </div>
            </div>
            <v-btn class="black-btn close-btn" @click="close_current_view">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>
    </div>
</template>

<script>
import { timeout, download_picture } from "@/utils/util.js";
import { favoritesFn } from "@/utils/favorites.js";
import { likesFn } from "@/utils/likes.js";
import { likes, downloads } from "@/api/interface.js";
import { mapMutations, mapState } from "vuex";
import informationModal from "@/components/information-modal/index";
export default {
    name: "picture-view-modal",
    props: {
        data: {
            type: Object,
            default: () => {
                return {};
            },
        },
        itemIndex: {
            type: Number,
            default: -1,
        },
        itemData: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            index: this.itemIndex,
            isLike: false,
            sub: -1,
            showInfomation: false,
            changeCurrentData: false,
        };
    },
    components: {
        informationModal,
    },
    watch: {
        itemIndex(nowIndex, oldIndex) {
            this.index = nowIndex;
        },
        //  数据变化，重新渲染标题部分
        async data() {
            this.changeCurrentData = false;
            await timeout(600);
            this.changeCurrentData = true;
        },
    },
    computed: {
        ...mapState("search", ["searchCondition"]),
        ...mapState("global", ["isNewBeveliver"]),
    },
    created() {
        this.data.likes =
            parseInt(this.data.likes) > 999
                ? "999+"
                : parseInt(this.data.likes);
    },
    mounted() {
        this.$P.$on("close_pictureviewer_information", () =>
            this.$refs.notesInformation.close_information()
        );
    },
    methods: {
        ...mapMutations("search", ["updateSearchCondition"]),
        ...mapMutations("triggerEvtents", [
            "updateGetSchemaData",
            "updateInitSearchCondition",
            "updateSnackbar",
        ]),
        //  关闭当前图片弹框
        async close_current_view() {
            this.$emit("modelHide");
            await timeout(100);
            this.locate_current_picture();
        },
        // 定位当前关闭的图片
        locate_current_picture() {
            let $el = $(`[data-postId="${this.data.id}"]`);

            let itemOffsetTop = $el.offset().top;
            let winScrollTop = $(window).scrollTop();
            let winHeight = window.innerHeight;
            if (itemOffsetTop < winScrollTop) {
                window.scrollTo(0, itemOffsetTop - winHeight / 3 - 74);
            } else {
                window.scrollTo(0, itemOffsetTop - winHeight / 3);
            }
        },
        //  上一张
        item_prev() {
            this.index--;
            this.index = this.index <= 0 ? 0 : this.index;
            this.$emit("modelArrowChange", this.index);
        },
        // 下一张
        item_next() {
            this.index++;
            this.index =
                this.index > this.itemData.dataAmount - 1
                    ? this.itemData.dataAmount - 1
                    : this.index;

            this.$emit("modelArrowChange", this.index);
        },
        //  点赞
        async likes(ev) {
            let likesData = await likesFn(
                ev,
                this.data.isLikes,
                this.data.likes,
                this.data.fileId
            );
            this.data.isLikes = likesData.isLikes;
            this.data.likes = likesData.likeNum;

            this.$emit(
                "likes",
                this.data.id,
                this.data.isLikes,
                this.data.likes
            );
        },
        //  收藏
        favorites() {
            favoritesFn(
                this.data.isFavorited,
                this.data.id,
                this.itemData.favorite_id,
                this.itemData.thumbnail
            );
        },

        //  下载
        async download(url, fileId) {
            let { data } = await downloads({ fileIds: [fileId] });
            window.location.href = url;
            // download_picture(url);

            this.$emit("downloads", this.data.id);
        },
        //  点击 Tag 刷新数据
        get_tags_schema(tagsName, key) {
            if (this.sub === key) return;
            this.updateInitSearchCondition();
            this.$P.schemaType = "search";

            this.updateSearchCondition({
                keyword: String(tagsName).trim(),
                lang: this.$store.state.global.currentLang.lang,
            });
            this.sub = key;
            this.updateGetSchemaData();
            window.flickity.selectCell(key);
        },
        // 复制图片路径(隐藏功能，给管理员用)
        copy_picture_path() {
            if (this.isNewBeveliver) return;
            this.$refs.filePathInput.focus();
            this.$refs.filePathInput.select();
            document.execCommand("copy");
            this.updateSnackbar(this.$TL.copySuccess);
        },

        //  开启卡片信息弹框
        open_information_modal() {
            this.$P.$emit("close_pictureitem_information");
            this.$refs.notesInformation.open_information();
        },
    },
};
</script>

<style lang="scss">
.picture-view-modal {
    width: 44.8vw;
    height: 100%;
    flex-shrink: 0;
    background-color: #141518;
    position: -webkit-sticky;
    position: sticky;
    top: 64px;
    right: 0;
    z-index: 222;

    .view-wrap {
        height: 100vh;
        width: 100%;
        &::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background: #5b5b5b;
        }
    }

    .view-modal-header,
    .view-modal-body {
        width: 100%;
        position: relative;
    }

    .view-modal-header {
        &:hover {
            .slide {
                opacity: 1;
                visibility: visible;
            }
        }

        .information-modal {
            top: auto;
            bottom: -8px;
            right: 10px;
            left: auto;
        }
    }

    .view-modal-body {
        padding: 0 36px;
        overflow: hidden;
        overflow-y: auto;
        height: calc(100% - 500px);

        &::-webkit-scrollbar-thumb {
            background-color: rgba(#fff, 0.5);
        }

        .picture-info-content {
            padding-bottom: 10vh;
        }

        .v-spinner-border {
            border-color: $color-white;
            border-right-color: transparent;

            position: absolute;
            left: 0;
            right: 0;
            top: 20%;
            margin: auto;
        }
    }

    .picture-info-content {
        padding-top: 24px;

        a,
        span,
        h3,
        h2,
        button,
        p,
        i {
            color: $color-white;
        }

        .modal-operation-area {
            margin-bottom: 16px;

            .file-path-box {
                position: relative;
            }

            .file-path {
                font-size: 13px;
                margin-bottom: 0;
            }

            .file-path-input {
                position: absolute;
                opacity: 0;
                bottom: -10px;
                z-index: -1;
                pointer-events: none;
            }

            .functional-area {
                min-width: 260px;
                flex-shrink: 0;
                justify-content: flex-end;

                .v-btn,
                .down-btn {
                    margin-left: 16px;
                    i {
                        padding: 0;
                        font-size: 20px;
                    }
                }

                .like-btn {
                    width: auto;
                    padding: 0 16px;
                    border-radius: 40px;

                    span {
                        span {
                            color: $color-white;
                            padding-left: 6px;
                        }
                    }
                }

                .down-btn {
                    padding: 8px 16px;
                    border-radius: 40px;

                    span {
                        font-size: 14px;
                    }

                    i {
                        margin-right: 2px;
                    }

                    span {
                        color: $color-white !important;
                    }

                    svg {
                        width: 20px;
                        path {
                            fill: $color-white;
                        }
                    }
                }
            }
        }

        .title-content {
            max-width: 100%;
            position: relative;

            .image-title {
                font-size: 18px;
                font-family: "Roboto", sans-serif;
                margin-bottom: 8px;
                font-weight: normal;
            }

            .update-date {
                font-size: 14px;
            }
        }

        .info-body {
            margin-top: 20px;

            h3 {
                font-size: 18px;
                font-weight: 700;
                margin-bottom: 8px;
                font-family: "Roboto", sans-serif;
            }

            .control,
            .control p {
                font-size: 14px;
            }

            .control p {
                margin-bottom: 16px;
            }

            .tags-content {
                margin-top: 20px;

                .tags-list {
                    margin-bottom: 50px;
                    a {
                        font-size: 14px;
                        font-family: "Roboto", sans-serif;
                        display: inline-block;
                        background-color: #333333;
                        margin-bottom: 12px;

                        &:hover {
                            background-color: #444444;
                        }

                        margin-right: 8px;
                        line-height: 1.2em;
                    }
                }
            }
        }
    }

    .float-image-box {
        width: 100%;
        padding-top: 56.5%;
        position: relative;
        overflow: hidden;

        iframe {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            transform: scale(1.01);
        }
    }

    .black-btn {
        width: 40px;
        height: 40px;
        background-color: #313133;
        border-radius: 50%;

        i {
            color: $color-white !important;
            font-size: 26px;
        }
    }

    .slide,
    .close-btn {
        position: absolute;
        z-index: 20;
    }

    .slide {
        opacity: 0;
        visibility: hidden;
        transition: all 0.35s ease;
    }

    .slide-prev,
    .slide-next {
        top: 0;
        bottom: 0;
        margin: auto;
    }

    .slide-prev {
        left: 36px;
    }

    .slide-next {
        right: 36px;
    }

    .close-btn {
        border-radius: 0;
        height: 42px;
        width: 42px;
        top: 12px;
        right: 10px;
    }
}
</style>
